export const API_KEY_CATS = 'dbc9a3ea-2d76-40cc-bfa7-827e62f4c23c'
